var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"vx-row justify-center w-full py-6 md:py-12 lg:py-24 mb-24 mx-1"},[_c('div',{staticClass:"vx-col w-full md:w-2/3 lg:w-1/2"},[_c(_vm.currentComponent,{tag:"component",attrs:{"mitra":_vm.mitra,"category":_vm.$route.query.ft}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }